import MenuComponent from '@/components/MenuComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'

export default {
  data () {
    return {
      loading: false
    }
  },
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated
  },
  methods: {
    getValueForDebitImmediatE () {
      if (!this.$store.state.entreprise.listOperations) {
        return 0
      }
      return this.$store.state.entreprise.listOperations.debitImmediatE
    },
    getValueForDebitImmediatP () {
      if (!this.$store.state.entreprise.listOperations) {
        return 0
      }
      return this.$store.state.entreprise.listOperations.debitImmediatP
    },
    formatDate (date) {
      var moment = require('moment')
      return moment(date).format('DD/MM/YYYY')
    },
    showOperationsCarte (echeance) {
      this.$store.dispatch('porteur/selectEditedEcheance', echeance)

      this.$router.push({ name: 'porteur/operationscarte' })
    },
    ajoutDebitImmediatEntreprise (debitEntreprise) {
      return debitEntreprise + this.$store.state.entreprise.listOperations.debitImmediatE
    },
    ajoutDebitImmediatPorteur (debitPorteur) {
      return debitPorteur + this.$store.state.entreprise.listOperations.debitImmediatP
    },
    ajoutDebitImmediatTotal (debitTotal) {
      return debitTotal + this.$store.state.entreprise.listOperations.debitImmediatP + this.$store.state.entreprise.listOperations.debitImmediatE
    }
  },
  mounted () {
    this.$store.dispatch('porteur/selectEditedEcheance', null)
    this.$store.dispatch('user/selectPeriode', this.$store.state.porteur.editedPeriode)
  },
  beforeCreate () {
    var moment = require('moment')
    if (this.$store.state.porteur && this.$store.state.porteur.editedPeriode) {
      this.$store.state.filArianePage = 'Opérations du ' + moment(this.$store.state.porteur.editedPeriode.dateDebut).format('DD/MM/YYYY') + ' au ' + moment(this.$store.state.porteur.editedPeriode.dateFin).format('DD/MM/YYYY')
    }
    this.$store.state.filArianeMiddlePage = 'Dépenses Entreprise'
    this.$store.state.filArianeMiddleRouterLink = 'entreprise/gestionnairedepenses'
  }
}
